import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-071729e8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "actions" }
const _hoisted_2 = { class: "action-title" }
const _hoisted_3 = { class: "action-info" }

import SvgIcon from '@/popup/components/shared/SvgIcon.vue'

type Props = {
  icon: string
  title: string
  description: string
}
type Emits = {
  (event: 'on-click'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AddProfileActionCard',
  props: {
    icon: {},
    title: {},
    description: {}
  },
  emits: ["on-click"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "wrapper px-4 py-2",
    onClick: _cache[0] || (_cache[0] = ($event: any) => (emits('on-click')))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(SvgIcon, {
        color: "var(--neutral-20)",
        name: _ctx.icon,
        height: "24",
        width: "24"
      }, null, 8 /* PROPS */, ["name"]),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.title), 1 /* TEXT */),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.description), 1 /* TEXT */)
      ]),
      _createVNode(SvgIcon, {
        color: "var(--neutral-20)",
        name: "arrow-right-lg",
        height: "24",
        width: "24"
      })
    ])
  ]))
}
}

})